var _style, _rect, _g, _path, _path2, _g2, _path3, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g11, _g12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 416.46 349.4",
    style: {
      enableBackground: "new 0 0 416.46 349.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:url(#SVGID_1_);}\n\t.st2{display:inline;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:url(#SVGID_2_);}\n\t.st5{fill:url(#SVGID_3_);}\n\t.st6{font-family:'Montserrat-Regular';}\n\t.st7{font-size:10.1922px;}\n\t.st8{fill:#3D4051;}\n\t.st9{fill:#00B294;}\n\t.st10{opacity:0.3;fill:#00B294;}\n\t.st11{fill:#5D39A8;}\n\t.st12{fill:#242C7D;}\n\t.st13{fill:#CADFEF;}\n\t.st14{fill:#FFE2B2;}\n\t.st15{fill:#FFDC17;}\n\t.st16{fill:#FF582A;}\n\t.st17{fill:#00823E;}\n\t.st18{fill:#00C75F;}\n\t.st19{fill:#E3270E;}\n\t.st20{fill:#CBD0E3;}\n\t.st21{fill:none;stroke:#FF582A;stroke-width:8;stroke-miterlimit:10;}\n\t.st22{fill:none;stroke:#FFDC17;stroke-width:5;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st23{opacity:0.59;fill:url(#SVGID_4_);}\n\t.st24{opacity:0.59;fill:url(#SVGID_5_);}\n\t.st25{opacity:0.59;fill:url(#SVGID_6_);}\n\t.st26{opacity:0.59;fill:url(#SVGID_7_);}\n\t.st27{fill:none;stroke:#3D4051;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st28{font-family:'Montserrat-Black';}\n\t.st29{font-size:50.471px;}\n\t.st30{fill:#F9FBFC;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND",
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.0315,
    y1: 686.5687,
    x2: 38.2465,
    y2: 246.7838
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF6B1F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1889,
    style: {
      stopColor: "#FF7121"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4467,
    style: {
      stopColor: "#FF8328"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7429,
    style: {
      stopColor: "#FF9F32"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFBE3D"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -333.54,
    className: "st1",
    width: 750,
    height: 500
  }))), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible",
      opacity: 0.7
    },
    width: 621,
    height: 406,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAm0AAAGWCAYAAAAqtrT5AAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAFkBJREFUeNrs3c+SG0di4OHMrALQ YDebNBktm/bEHCZiLuLc5gV4mFfgvI40r2O+wh74Ar5ZvEyEDg45uKsOyhS7STSAqszNLKBbTUo0 OQ7Hhlf4Pg6Ev12oGFx+kVmVFQIAAP/jxf8h2wAA+LUr/y+DK/7y9/5FuAEAfNRX5SP59dkhFz// M+X9OHv6TXwant48PT9/IdwAAD5wdvblTZg9q//Cs8fl/ZiLnxVwnwqteBNrNdJqqYUnNc4uLh5N f3d19TKGL0NYXz54bzu/9/sAAAfsrx88X5z8UMKLEI6OHk1hdvfuy/J8irnriLuJt/K3Rtv+9a/r /TfxyZPHU6i1SFv/9kE8ez2kzeZN3D48juPmbf3MWbi/vYzhoR8JAODGqxBez05qiJ2Hbn5cZq/e lvn8tJzf7/Pi334oLeKmgHv+Tf1Mi7evr6Ot/A3R9vU0uvbk/HE8Pw/p7VlID++GdHVxlk6WY1qv xrRclDQOV3Ec5zEvN/VvTsI4ruOJnwgAOGCX9dZ1i9IepdW8dN2mdP1RWa1jXiy7fLnq8tHd8/zq IuTj85DPzkJ+flbD7dlNuH1WtN0E2x+//bv04xd/SG1k7c1i0c3CeT/v5t1VN+tmse/69aYb+pJy 7uNi3sWch1jqYz8VAHDoYhpKSn1Zb8Z6P5R+iHlYzMdtGcajcTtu6r9tOBtO1+uxjbzd+/5f87/8 7j/yx8Kt/3mwtff/PI2wfffFg3Tv+x+6/EX9XD7th2E2W5aj/k6Ks02p3z3v+hRTV8rY5ZJjfSmW UO/zGGd+KwDgAG2nYOtKKH2pfVRiLaTUzcch5bG+ONxJNd+Gbjt0ZQj9OuXlm+He92H48Ys/hCfn P5Tn4ZvWa+0Yt3g73OLPo+3r+ORJSG1K9PT0tMv338zKZj4b++U8b8f5LMZF7vK8DP28pDyPdY9a uKVcn6WQwhRvMXZta50fDgA4IOP0v9BCrZZbjaOQc4q5xlsNtjjEnDaxHzZpTJttKes06zbdsNrE +WabXp9u37x5M05Tpc9D/nC07YORtvr60z/Hi2//FN+evUwhLLo2wnbUx/m2DEd96o/GvF3GEpZd PyzyEBchlXkppc8xdyV2KZUabnVf837HAQAOSdzdSo411uKYS0ljDKUGW9ikfljXF9ZjGVexFlvt qxT6ZbjKRyUsFvntWShHF49KePq/YnhWbi8H8l60xd06bE/D1dWL+PAfQxovzqcp0VwW8xZsfSzH peuPSyjHtRfvhC4sU4iLuslZDLGvEdm1toytL1NxbBsAcHjRluNuhKzGUm2iNoQ11Dra5i6s8xhX IaV3qYt9DbkUch9yHmvfreujN/nh3ZCvzl/mMK2Fe7M+bvkw2iZtHbbvfvsghosuHXc/du0YtjGW RRtha8EWc7mbYz5NMZ6UUu7UYFuW+n7dWjsDoW6v5VqZ9iMU4QYAHFKxtaPE8jTSVm85hzKEdsth XV9c1Xh7l0uep5Lq/2rS5W3uYzceleUwdnF4e3EvrX87xtZjzz9xIkJo67Gdrd+mfD+k1Tjr2kkH tQDnbUp0GmGrwRZCutfu62t3S4x36k4t6mbnbXs1LlPaz+S2XXdlUgDgIOzG12oaxZLbyFWtt5pB Q22hTS24dX3zXe2ki1BSN05hl3LswlCbapNSv7nKs+3JfEynr4d0sXmUQ3gZPhJtu+PZwrePQls4 d1zdS7NF37WzROPQz6dj2MZyp42wTSNtJd6vf3Ra9+2kttlRG22r9220rWsTsG08MJTpBgBwGHbl 00bZ2nzj2EbZahK1YLuq94tYQlc7KtSOGksum9TFq7F21mZW+racWlsHt6sdFsLxdMnQ28e1vTfS 1q4l+uLqRez+6Tgex5Lyetu1ZT1KivPppIMuLNuUaBtha8FWd+B+3YEabWU32hbCrG54f1xbC8y2 z8kPCAAcgLxfOy1eh1s7nm1bH65rL72r9/00CVlCW/pjHVJctb6aVuMope83YzdfzNLb+XEc//3l dI33Z7e23t904bUv6zecv431z+LYp9SW88jtKLlU5vuTDpZtSrSNsO2CrcZbqc9jOKo7005IaAuT pDgtLhL3+wwA8Gs3xVqbIZ2OZ6v3Ndritr56VZOo3w3DtWPc4rpG2rKG0iLXvmrnBLTeGvqh/qdd aWozXdv99obDrviutTMUvpwu/t6G1MZxFXOttLZwbpe6ri3r0c4SbdOgu1G12CLtTgu2+sfH9bX6 PLbj2rr98FoMwRFtAMBBKfsrFeT9maOb1kbTK3GaKr2qjxb1Q4v6yTZDWYMtduMwdu2ItN1g3b3a Y2MMJ9d99gtnj56fv4hh+WC6+Pu70zEuagS2Kx3EoaS2Dtu0rEf7mxLm1/HWRth2wVaWtdVm+xDc RdsUmroNADiIXpvOHt1HVq5PhnrXtbnH+kKtsLAuofZTifM28hanZipdyim1dGv/1nEV778Z4/9Z Lndd9vHFdfce1tv2JOS83l2aqm6tLZzb1mHbLesxDfG1+xZps90I2xRs8/02d9G220nVBgD86sX9 9OhP0dbWP2tJ1KZJy6Z+YrbvpGmZtFyDLUwXlWrrtaWY4xBDd1I7bLW7FtYH+o998TiuY5931xKN 9ba70kG7BlYbdZuOWWsnHLTRt3axqm4/wtbvHk+3GIJiAwAOTou2/XWhSrtI1E0vxRpqJYbUam4a 3cpj2p+50Abe4hjWMXzkAu4/i7bf19ubemvTqNvpq8a6zTQdnzZd6aD+S7uxv7gbA5wCrmXk9a3t 1LQDUbEBAIdUa7tAuj3ilvZdtIu0di35KdLadeR3PTXdyhhjTbmTWz22+lS0fWgWbsb4pmsdtJG+ tnBu2U1+xvjTCQc3t/1l6aMTRwGAQzKdH7oLovfaaPe81EaKu3Vs213rqvzT9OSnLtnef9YedLe2 tLs01fSFbdQtXs+ClrIPyN2e7YJNtQEAB5Vtu/Gzcqub9nOPbXQtXF8xqty6alTrrOHTW/6vrXwb 3/vz+FNbOoQNAGAXaeH2Kho/XXDgv1hLLlcAAPD/AdEGACDaAAAQbQAAog0AANEGAIBoAwAQbQAA iDYAAEQbAIBoAwBAtAEAiDYAAEQbAACiDQBAtAEAINoAABBtAACiDQAA0QYAgGgDABBtAACINgAA 0QYAgGgDAEC0AQCINgAARBsAAKINAEC0AQAg2gAARBsAAKINAADRBgAg2gAAEG0AAIg2AADRBgCA aAMAQLQBAIg2AABEGwCAaAMAQLQBACDaAABEGwAAog0AANEGACDaAAAQbQAAog0AANEGAIBoAwAQ bQAAiDYAAEQbAIBoAwBAtAEAINoAAEQbAACiDQBAtAEAINoAABBtAACiDQAA0QYAgGgDABBtAACI NgAA0QYAgGgDAEC0AQCINgAARBsAAKINAEC0AQAg2gAAEG0AAKINAADRBgAg2gAAEG0AAIg2AADR BgCAaAMAQLQBAIg2AABEGwCAaAMAQLQBACDaAABEGwAAog0AANEGACDaAAAQbQAAiDYAANEGAIBo AwAQbQAAiDYAAEQbAIBoAwBAtAEAINoAAEQbAACiDQBAtAEAINoAABBtAACiDQAA0QYAgGgDABBt AACINgAARBsAgGgDAEC0AQCINgAARBsAAKINAEC0AQAg2gAAEG0AAKINAADRBgAg2gAAEG0AAIg2 AADRBgCAaAMAQLQBAIg2AABEGwAAog0AQLQBACDaAABEGwAAog0AANEGACDaAAAQbQAAiDYAANEG AIBoAwAQbQAAiDYAAEQbAIBoAwBAtAEAINoAAEQbAACiDQAA0QYAINoAABBtAACiDQAA0QYAgGgD ABBtAACINgAARBsAgGgDAEC0AQCINgAARBsAAKINAEC0AQAg2gAAEG0AAKINAADRBgCAaAMAEG0A AIg2AADRBgCAaAMAQLQBAIg2AABEGwAAog0AQLQBACDaAABEGwAAog0AANEGACDaAAAQbQAAiDYA ANEGAIBoAwBAtAEAiDYAAEQbAIBoAwBAtAEAINoAAEQbAACiDQAA0QYAINoAABBtAACiDQAA0QYA gGgDABBtAACINgAARBsAgGgDAEC0AQAg2gAARBsAAKINAEC0AQAg2gAAEG0AAKINAADRBgCAaAMA EG0AAIg2AADRBgCAaAMAQLQBAIg2AABEGwAAog0AQLQBACDaAAAQbQAAog0AANEGACDaAAAQbQAA iDYAANEGAIBoAwBAtAEAiDYAAEQbAIBo838BAIBoAwBAtAEAiDYAAEQbAACiDQBAtAEAINoAABBt AACiDQAA0QYAINoAABBtAACINgAA0QYAgGgDAEC0AQCINgAARBsAAKINAEC0AQAg2gAARBsAAKIN AADRBgAg2gAAEG0AAIg2AADRBgCAaAMAEG0AAIg2AABEGwCAaAMAQLQBACDaAABEGwAAog0AANEG ACDaAAAQbQAAog0AANEGAIBoAwAQbQAAiDYAAEQbAIBoAwBAtAEAiDYAAEQbAACiDQBAtAEAINoA ABBtAACiDQAA0QYAgGgDABBtAACINgAA0QYAgGgDAEC0AQCINgAARBsAAKINAEC0AQAg2gAARBsA AKINAADRBgAg2gAAEG0AAIg2AADRBgCAaAMAQLQBAIg2AABEGwCAaAMAQLQBACDaAABEGwAAog0A ANEGACDaAAAQbQAAog0AANEGAIBoAwAQbQAAiDYAAEQbAIBoAwBAtAEAINoAAEQbAACiDQBAtAEA INoAABBtAACiDQAA0QYAgGgDABBtAACINgAA0QYAgGgDAEC0AQCINgAARBsAAKINAEC0AQAg2gAA EG0AAKINAADRBgAg2j6lXD/It56VEG+9AwBwyHZdVG7VU/6go/42/Wd9ary9B7GEMhVauRVpZXr9 +klpO9qeRhEHAByQsu+gW92076VYu6jc6qibjBr/m6JtuyvF3S23L8v1+693oD6vu7aPt5tb3HXb 7Y4DAPj1J1u5HmF7/1amPor11rqtPa/dltN0P+4/9Knpz59F21/r7e/r7bLeFi28Ule/IN+EWbvP t0It7sb6bt/GXU3uB9sAAA7EfoSt7Hvopo92vTS1W2kP0jRLWaaImz4fu6maWn/d3ffYbz4Vbde6 blE3tK4B2E8byzHmkMcp0montoob6+OxfqDex7pjcdjtw83Oxv2D6CcEAA4g2MqtDmqxNuz76KaX ap2NsbTRsJKnidTUtXnMmlWpxDiU1l8hrH5x+78cba/q7fQypLSsW6zbHULOcczty3IoQ5x2otRb mz2NbQZ1U/et2w3stYCcHuxHADUbAHAIyu1j2PIu2HJrpc2ul8r2OuTqB4bUIi6POZWUS59Lim2g 7LJ2WE2q009E29nZl+W7y/8dXs9OytFqVdZpbMfLla5WYClpDNexFsOmxti6Pl7XXbuqr3d1J9s+ jtPj62iLUbEBAAfiepLxOtpaF9Vgq61U37mqb6+nfoptsCvUcGvxFmu1xTwOY2lSnpfXs2Vps6ut y0J48UvR9lV941lcnPxQ2qhc183rdmr7dfOxRuAY2whbrJWYw7rNm9YdqTsQ39Uv7vfnP9QdKy3m 2qRsij9Niwo3AOAQlP1/psPJyi7atvtge1cfv6uvXdX7Nui1rpm1rZ025BLHru9qbW1KF+ufjZdh cdI28w/7Pvv6vWi7OQatBV33T8f1j7oS19s8pNzmX4eYwyZ3odVhTbryrsbZot73u1MOpinTGnJx VrfQxWnYrbRzWqP1ewGAw5DD7gzROJ1wsDvmv2zDNNgVa7SVy/raZe2jd/XNVWntlOOmpFjDLY99 ra20OCpdNyvji7chfPl+DL43Pfqs/vvj0Z9KePWyrO7ey91i3g6cq5uIm9QP6zzGVYzxXY7lou5O tztBtAVbvKr37WTTvr7SpkdjW7jNersAwOFoi9jG/RmhpZQp2kLrpHZmZ5uhbCeHvqkfuEglvis5 rFJf1mXoNqUrw7DoxrFm3OzibZkdPSqty0J4erP1/vYXhWdfl/DHEObz05KXXV6N6/FOrbWhHza5 lHVI6V0twXko7VSH3MqsDfvVegyLuovztr12+kPa1dxueTeTowDAIdgdzTatw5Z3U467kxGmY9im cGsjbBe1o97kkC/jrqvWsXbWrP7nXR7G5XKR0/q0bNpRb88ev7cIx8/OHr1792X5bvkgL1ZdPu62 Yxy6bYppM5ZxlbrYp5LSWIOtFmIbhVvHUpZ1Bxbt2La62b4GW5qmRacZUmu1AQAHZL9wbprmR9uy Hu0kzjC0Y9jalGgbYWvB1tVwq3X3No9h1dXOikPZHsXteLm5k9f3Q/7N6uXPCupn0fb87Mvy+MWL cvS7kDcXYRy6MszKYh3TrKv7UZutDZ6lthLIJqQ2XVqDrcRZfa/PoUzHs8U2NpiKUTYA4MDsrnTQ Fs5t67Cl3dpsw3TSQajhlsOqjbC1YKuZ9Lak2Wqbx/W7eDX043Y8unuew7ehPP/y/TNHP4y2+uZX 9e7P8ejoT+XVxct8HM6G0K9T/cK0LUMKua87ss2xC0Pq4lUe4qLu17xmZd1O6ULq6mfGNI3lZT8b AHCI2VZ2A25tybQ85nZsWztLNEznCJR1mxJtI2wt2IY0XM26flPCcrsd7w+vL87zw6NHbUWPuqV/ bmeOll+KtnB9XNvdJy/L1XnIp6frMS/fDGUzj6Ffhly/uI/dmGPejEM/b4uJTFOiMXYpp9QWcyu7 q8THdjbCtGIbAMChGG+u/17aYFtbOLetw9aW9WhnibaTDtoxbG1KtI2wtWDrhtXmZL4Z0vp0DG9C vnv2snx4PNu+0j583oLuz+nJk8fxu+WD7t73P3T9F6G/zKd9HFazu2XZl3mcbUrpY8k12FI3DmPX 10el7lUpud6P09ofAACHpl32YLp2e0wlplyGIZdpHbbSrgeahnmMQ9yU7UVcDaVfbk/Sm2H4Pgw/ fvFg/M3qh/H5829qjP1zvrVY7+TDY9qm6y+0objnZ9+EP377d/nHL/4Qzl4PJSwWuQ9v8tjF4SrP trPY1zYcu6EfUuu3Gm8x130I9XFM6boyAQAOyvUKte1aou3SVE1bOLetw9aW9WhnibaTDtoxbG1K tI2w/fhFn+99/6/5+e/+o7bYzSjbeycjfOxUgRZuMTz9Jj45fxzPz0N6exbSw7shXV2cpZPlmNar MS0XJY3DVRzHeczLTf2bkzCO63ji9wIADlhbkG138ffLkFbz0rWl2PqjslrHvFh2+XLV5XbSwauL kI/PQz47C/n52Tf7adGvS/iFhW7/k2hrariFGm5PHseLi0fx6uplXP/2QTx7PaTN5k3cPjyO46ad /HAW7m8vY3joRwIAuPEqTNd0D+E8dPPjMnv1trT1cM/v93nxbz+Uo6NHpS23tpsSfXz7xIPPjrZb 77e/+cs06tZW5X1y/mIKuPZmi7h2iYX15YP3tvN7PxEAcMD++sHz6druL0I4ms4M3a2L+3y6IPyz /SK6X/3ilOjfEm23PrOPt2s14p7eurTCeY05PxEAwPvOpjjbeXYTade+un2WaPmMIPtstz5/e7t/ EWwAAB/1VflIfn32taP+O2JLsAEAfJqLewIA/Nr9XwEGALuYGEDiGQAEAAAAAElFTkSuQmCC",
    transform: "matrix(1 0 0 1 -272.5372 34)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -261.82,
    y: 44,
    className: "st3",
    width: 596.26,
    height: 381.69
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.094947e-13,
    y1: 174.8646,
    x2: 416.356,
    y2: 174.8646
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8EE5B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C4D8"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M416.36,0.33v304.23c0,0-63.03-57.53-120.82,11.64c-39.9,47.76-143.04,48.42-173.54-27.37 c-28.69-71.31,31.66-90.08-28.69-92.29c-74.14-2.71-5.45-47.05-36.97-73.24C25.04,97.27-32.59,43.32,23.69,0.33H416.36z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 159.0587,
    y1: 110.2628,
    x2: 416.356,
    y2: 110.2628
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#87E5B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00D5EB"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M416.36,0.33v199.79c0,0-61.11,35.53-104.77-4.82c-43.66-40.36-65.34,29.55-98,24.64 c-32.67-4.91,11.75-54.32-53.72-43.07c0,0-2.3-7.69,22.84-8.32c25.13-0.63,48.69-5.57,46.28-21.85 c-2.4-16.28-78.27-35.82-69.17-75.56c9.01-39.37,84.5-40.62,80.56-70.81h20.33c-3.47,9.29-5.15,22.62,11.7,25.74 c18.24,3.38,29.28-13.26,34.89-25.74h10.61c-1.36,4.84-1.84,11.8,7.36,10.26c5.56-0.92,7.89-5.74,7.83-10.26H416.36z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -234.0353 81.2773)",
    className: "st8",
    style: {
      fontFamily: "'Montserrat-Bold'",
      fontSize: "9.9474px"
    }
  }, "YOURLOGO")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 70.0388 80.8891)",
    className: "st3 st6 st7"
  }, "Home")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 127.989 80.8891)",
    className: "st3 st6 st7"
  }, "About")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 190.489 80.8891)",
    className: "st3 st6 st7"
  }, "Blog")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 240.2234 80.8891)",
    className: "st3 st6 st7"
  }, "Contact")))))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -233.9045 203.4301)",
    className: "st9 st28",
    style: {
      fontSize: "32.0326px"
    }
  }, "BACK TO")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -233.9045 240.2865)",
    className: "st9 st28",
    style: {
      fontSize: "36.4007px"
    }
  }, "SCHOOL")))), /*#__PURE__*/React.createElement("rect", {
    x: -234.07,
    y: 286.36,
    style: {
      display: "inline",
      fill: "none"
    },
    width: 131.53,
    height: 25.99
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -234.0735 291.5292)",
    className: "st2"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st6",
    style: {
      fill: "#909FAB",
      fontSize: "7.2801px"
    }
  }, "Lorem ipsum dolor sit amet, consec"), /*#__PURE__*/React.createElement("tspan", {
    x: 119.86,
    y: 0,
    className: "st6",
    style: {
      fill: "#909FAB",
      fontSize: "7.2801px"
    }
  }, "-"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 8.74,
    className: "st6",
    style: {
      fill: "#909FAB",
      fontSize: "7.2801px"
    }
  }, "tetuer adipiscing elit, sed diam "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17.47,
    className: "st6",
    style: {
      fill: "#909FAB",
      fontSize: "7.2801px"
    }
  }, "nonummy nibh euismod")), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-175.59,273.9h-49.9c-4.74,0-8.58-3.84-8.58-8.58v0c0-4.74,3.84-8.58,8.58-8.58h49.9 c4.74,0,8.58,3.84,8.58,8.58v0C-167.02,270.06-170.86,273.9-175.59,273.9z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -223.4983 267.3906)",
    className: "st3",
    style: {
      fontFamily: "'Montserrat-Bold'",
      fontSize: "7.2801px"
    }
  }, "READ MORE")), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: -231,
    cy: 331.24,
    r: 3.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-216.06,331.24c0,1.69-1.37,3.07-3.07,3.07c-1.69,0-3.07-1.37-3.07-3.07c0-1.69,1.37-3.07,3.07-3.07 C-217.43,328.17-216.06,329.54-216.06,331.24z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: -207.25,
    cy: 331.24,
    r: 3.07
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M349.18,162.52c-3.25,2.13-12.91,12.3-17.93,18.22c-25.82,30.5-54.17,68.17-51.48,70.45 c2.69,2.28,35.4-31.7,61.22-62.2c5.02-5.92,13.47-16.94,15.02-20.69L349.18,162.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M341,189c5.02-5.92,13.47-16.94,15.02-20.69l-6.83-5.79c-3.25,2.13-12.91,12.3-17.93,18.22 c-0.56,0.66-1.13,1.33-1.7,2.01l9.74,8.24C339.87,190.33,340.44,189.65,341,189z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M285.16,247.6c-2.99,2.66-4.92,4-5.39,3.6c-2.69-2.28,25.66-39.97,51.48-70.46 c5.02-5.93,14.68-16.09,17.93-18.22l2.73,2.31c-3.24,2.13-12.91,12.29-17.93,18.22C312.74,208.15,295,231.85,285.16,247.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M351.9,164.84c-3.24,2.14-12.9,12.29-17.93,18.22c-0.56,0.66-1.11,1.32-1.68,2.01l-2.73-2.31 c0.57-0.68,1.12-1.35,1.68-2.01c5.02-5.93,14.68-16.1,17.93-18.22L351.9,164.84z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M350.42,167.67c-1.58-1.43-2.62-3.57-2.59-6.21c0.03-2.73,1.66-5.43,3.72-7.48 c2.96-2.96,6.82-4.85,10.71-5.69c3.88-0.82,7.02-3.36,7.68-9.35c-0.48,0.22,4.59,9.79-4.16,15.04c-7.6,4.56,1.21,6.85-3.21,12.41 C359.18,170.65,353.72,170.7,350.42,167.67z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M42.15,9.99c1.02,0.5,1.92,1.25,2.61,2.21c0.03,0.04,0.05,0.08,0.08,0.13l1.49,2.44l0.41,0.67 c0,0.01,0.01,0.03,0.02,0.03l0.52,0.85l1.6,2.64l0.08,0.12l24.8,40.66l1.27,9.01l1.2,8.46l-6.99-4.92l-7.45-5.23L36.2,25.1 l-0.89-1.47l0-0.01l-0.94-1.53l0.02-0.01l-1.31-2.13c-2.02-3.3-0.98-7.63,2.32-9.65C37.53,9.01,40.06,8.97,42.15,9.99z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "61.79,67.05 73.76,59.72 75.03,68.74 76.23,77.2 69.24,72.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "69.24,72.28 75.03,68.74 76.23,77.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M42.15,9.99c1.02,0.5,1.92,1.25,2.61,2.21c0.03,0.04,0.05,0.08,0.08,0.13c0.07,0.09,0.14,0.19,0.2,0.3 l1.3,2.14l0.29,0.46c0.05,0.07,0.08,0.14,0.11,0.21c0,0.01,0.01,0.03,0.02,0.03c0.15,0.33,0.23,0.68,0.23,1.03 c0.01,0.91-0.44,1.8-1.27,2.31l-7.45,4.56c-0.84,0.5-1.83,0.5-2.63,0.06c-0.4-0.21-0.75-0.52-1-0.93l-0.25-0.41l-1.31-2.13 c-2.02-3.3-0.98-7.63,2.32-9.65C37.53,9.01,40.06,8.97,42.15,9.99z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "46.35,14.77 46.63,15.23 47.29,16.31 48.9,18.94 48.88,18.96 47.76,19.64 36.93,26.27 36.21,25.1  35.31,23.62 34.37,22.1 34.39,22.08 46.33,14.77  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "65.03,65.07 40.43,24.13 45.57,20.98 70.2,61.9  "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "395.1,89.86 328.5,61.97 356.11,118.07 373.78,103.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "378.71,114.8 383.89,96.81 328.5,61.97 373.78,103.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "368.75,107.35 378.71,114.8 373.78,103.09  "
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M308.76,126.65c-5.97,0.3-10.71,4.53-11.51,10.49c-0.25,1.88,2.64,2.57,2.9,0.67 c0.63-4.65,3.98-7.95,8.71-8.19C310.77,129.52,310.68,126.55,308.76,126.65z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M320.02,151.88c-6.23,20.5-28.44,15.82-28.44,15.82s-13.2-3.45-17.08-14.88c0-0.01,0-0.01,0-0.01 c-1.11-3.26-1.46-7.17-0.53-11.84c2.1-10.5,8.2-12.81,12.09-13.82c3.81-0.99,7.16,0.67,9.78,2.73l2.95,2.31 c0.91,0.71,2.08,1.01,3.22,0.81l3.69-0.64c1.82-0.32,3.9-0.13,5.89,0.37c0,0,0.04,0.01,0.12,0.03c1.56,0.4,3.05,1,4.33,1.68 C319.76,136.44,323.14,141.63,320.02,151.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M302.18,128.06c-7.67-10.45,2.71-17.01,4.5-18.04c0.17-0.09,0.26-0.14,0.26-0.14 C316.25,123.4,302.18,128.06,302.18,128.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M306.68,110.02c-1.75,3.06-4.69,9.52-4.5,18.04C294.51,117.61,304.89,111.05,306.68,110.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M320.02,151.88c-6.23,20.5-28.44,15.82-28.44,15.82s-13.2-3.45-17.08-14.88c0-0.01,0-0.01,0-0.01 s1.28,3.13,5.03,5.29c5.38,3.1,13.1,3.58,20.4,1.27c9.09-2.88,12.95-11.88,13.72-21.66c0.33-4.21-2.06-4.98-2.06-4.98 s0.04,0.01,0.12,0.03c1.56,0.4,3.05,1,4.33,1.68C319.76,136.44,323.14,141.63,320.02,151.88z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M287.71,130.99c0,0-5.27-0.46-3.57,2.78C285.84,137.02,291.74,132.46,287.71,130.99z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 106.69,
    y: 76.29,
    transform: "matrix(0.4898 -0.8718 0.8718 0.4898 -10.1233 147.3402)",
    className: "st3",
    width: 28.28,
    height: 12.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M119.61,90.4l0.47,40.02c0.03,2.57-2.74,4.21-4.98,2.95l-34.89-19.61c-2.24-1.26-2.28-4.48-0.07-5.79 l34.43-20.42C116.78,86.25,119.58,87.83,119.61,90.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M116.44,125.6c0.02,1.97-2.1,3.24-3.82,2.27L86.2,113.03c-1.72-0.97-1.76-3.44-0.05-4.44l0.74-0.44 c3.68,1.68,10.63,4.05,17.08,1.61c5.27-1.99,8.62-4.48,12.22-5.67L116.44,125.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M132.9,75.05l-11.78-6.62c-0.99-0.55-1.34-1.81-0.79-2.8l0,0c0.55-0.99,1.81-1.34,2.8-0.79l11.78,6.62 c0.99,0.55,1.34,1.81,0.79,2.8l0,0C135.14,75.25,133.88,75.61,132.9,75.05z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "121.58,68.69 132.08,74.6 131.08,76.38 120.77,70.14  "
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M276.26,207.96l-67.27-27.72l41.53,72.29L276.26,207.96z M261.06,213.11l-10.45,19.82l-19.3-33.13 L261.06,213.11z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "214.18,189.29 215.58,188.34 214.96,187.33 213.52,188.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "218.76,197.26 220.16,196.31 219.55,195.3 218.11,196.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "223.35,205.24 224.75,204.28 224.13,203.28 222.69,204.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "227.93,213.21 229.33,212.26 228.71,211.25 227.28,212.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "232.51,221.18 233.92,220.23 233.3,219.22 231.86,220.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "237.1,229.15 238.5,228.2 237.88,227.2 236.44,228.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "241.68,237.13 243.08,236.17 242.46,235.17 241.03,235.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "246.26,245.1 247.67,244.15 247.05,243.14 245.61,243.96  "
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 106.23,
    cy: 25.15,
    r: 5.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 388.98,
    cy: 264.15,
    r: 5.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 248.2,
    cy: 168.16,
    r: 5.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 405.69,
    cy: 135.15,
    r: 5.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M306.68,56.63c-1.8,1.28-2.84,2.31-4.11,4.11c-1.28-1.8-2.31-2.84-4.11-4.11c1.8-1.28,2.84-2.31,4.11-4.11 C303.85,54.32,304.88,55.35,306.68,56.63z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 332.09,
    cy: 230.55,
    r: 2.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 385.92,
    cy: 20.23,
    r: 2.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.05,50.69c0,1.15-0.93,2.07-2.07,2.07c-1.15,0-2.07-0.93-2.07-2.07s0.93-2.07,2.07-2.07 C97.12,48.61,98.05,49.54,98.05,50.69z"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M187.82,274.2c-1.03,0-3.77-0.38-4.04-4.41l-0.6-9.11c-0.39-6-0.92-14.23-1.5-23.12 c-1.15-17.78-2.47-38.2-3.15-48.8c-0.13-1.95-1.76-3.48-3.72-3.48h-17.94v-8h17.94c6.17,0,11.31,4.82,11.7,10.97 c3.42,53.06,5.2,80.51,5.29,81.6l-3.98,0.33l0,0.03h4l-3.87,4C187.91,274.2,187.87,274.2,187.82,274.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M146.31,157.01h-22.64c-4.43,0-8.02,3.59-8.02,8.02l0,0c0,4.43,3.59,8.02,8.02,8.02h22.64 c4.43,0,8.02-3.59,8.02-8.02l0,0C154.33,160.6,150.74,157.01,146.31,157.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M175.35,173.36v119.36H79.62c-7.96,0-14.37-6.51-14.29-14.47c0.25-24.34,4.94-45.81,10.73-63.14 c5.1-15.3,11.06-27.39,15.55-35.41c3.87-6.9,11.17-11.15,19.08-11.15h59.86C173.2,168.55,175.35,170.7,175.35,173.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M84.57,231.31c-1.48,7.8-4.34,23.32-6,35.49c-0.53,3.86,2.48,7.28,6.37,7.28h49.97 c3.92,0,7.22-2.93,7.69-6.81l4.48-36.97c0.32-2.67-1.79-5.01-4.48-4.96l-52.06,0.95C87.61,226.33,85.11,228.43,84.57,231.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M88.13,150c-1.42,1.01-2.23,1.82-3.24,3.24c-1.01-1.42-1.82-2.23-3.24-3.24c1.42-1.01,2.23-1.82,3.24-3.24 C85.9,148.18,86.71,148.99,88.13,150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M106.36,225.87l-3.64,22.43c0,0,13.21,0.52,13.21,0c0-0.43,2.31-16.58,3.16-22.46 c0.16-1.12-0.71-2.12-1.84-2.12h-8.37C107.63,223.72,106.56,224.63,106.36,225.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M101.11,244.74h16.22c1.01,0,1.78,0.92,1.58,1.91c-0.71,3.51-3.14,10.58-11.31,10.23 c-8.69-0.37-8.37-7.95-7.9-10.94C99.81,245.25,100.41,244.74,101.11,244.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M175.35,173.35v119.37h-19.77v-68.99c0-4.76-3.86-8.62-8.62-8.62h-70.9c5.1-15.3,11.06-27.39,15.55-35.41 c3.87-6.9,11.17-11.15,19.08-11.15h59.86C173.2,168.55,175.35,170.7,175.35,173.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M175.34,170.79c0-3.09-2.5-5.59-5.59-5.59H157.2h-19.59h-31.14c-8.15,0-15.56,4.74-18.98,12.14L74.56,205.3 c-1.58,3.42,0.92,7.32,4.68,7.32h60.68c5.23,0,9.7-3.76,10.59-8.91l2.8-16.11c1.07-6.18,6.44-10.7,12.71-10.7h9.32V170.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M165.71,225.33h6.08c3.89,0,7.03,3.15,7.02,7.03c-0.02,10.65-0.05,29.68,0.02,30.28 c0.07,0.63-9.39-0.44-13.99-0.99c-1.37-0.17-2.36-1.38-2.26-2.75l0.55-31.18C163.23,226.38,164.35,225.33,165.71,225.33z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.7,
    y: 176.9,
    className: "st8",
    width: 3.96,
    height: 41.42
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "168.67,210 163.13,222.5 173.45,222.5  "
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M240.24,296.64c0,0-8.12-19.61-24.14-21.42c-16.02-1.81-47.91,17.51-101.78,17.51l-9.97,15.12h135.89 V296.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M240.24,296.64c0,0,3.47-30.87-5.08-35.24c-10.61-5.42-53.14,10.42-88.25-29.74l-31.76,49.44 c-3.73,1.65,15.71,13.42,52.51,13.47C205.97,294.63,222.4,272.97,240.24,296.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M240.25,296.64c0,0,8.12-19.61,24.14-21.42c16.02-1.81,50.48,21.42,104.36,21.42l7.39,11.22H240.25V296.64z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M240.24,294.35c0,0,5.52-26.08,20.75-31.44c16.91-5.96,46.4,14,62.32,12.2c6.66-0.75,23.75-6.7,23.75-6.7 l21.68,28.24c0,0-34.98-0.34-45.63-1.52c-13.1-1.46-38.51-17.38-57.81-14.65c-19.29,2.73-25.07,16.17-25.07,16.17V294.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M250.44,319.21h-20.38c-5.83,0-10.56-4.73-10.56-10.56l0,0h41.5l0,0 C260.99,314.49,256.27,319.21,250.44,319.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M249.44,302.31h-18.4c-5.26,0-9.53,4.27-9.53,9.53l0,0h37.47l0,0C258.97,306.58,254.71,302.31,249.44,302.31 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M100.54,310.26h119.37c0,5.72,4.64,10.35,10.35,10.35h19.99c5.72,0,10.35-4.64,10.35-10.35l0,0h121.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M211.72,339.67l-14.13-11.2l-7.31,11.2c0,0-2.6-8.49-3.45-24.17c-0.06-1.11-0.11-2.26-0.15-3.45 c-0.05-1.35-0.08-2.75-0.09-4.19v-0.01c-0.03-1.77-0.02-3.62,0.01-5.53c0.02-0.67,0.03-1.34,0.04-2.03 c0-0.16,0.01-0.32,0.01-0.48c0-0.18,0.01-0.36,0.02-0.54c7.83-1.03,15.21-2.47,21.4-4.47c-0.01,0.35-0.03,0.71-0.05,1.07 c-0.03,0.56-0.05,1.12-0.08,1.68c-0.01,0.38-0.03,0.76-0.04,1.14c-0.08,2.05-0.13,4.14-0.16,6.25c-0.01,0.95-0.02,1.9-0.02,2.85 c0,2.72,0.06,5.45,0.19,8.15C208.33,324.58,209.44,332.91,211.72,339.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M213.56,321.64c-0.06,0.02-0.14,0.02-0.21,0C213.54,321.62,213.62,321.62,213.56,321.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M362.96,302.81l-39.22-0.71c-3.9-0.07-7.68-0.9-11.23-2.48c-8.01-3.55-27.83-11.85-38.99-12.27 c-12.66-0.49-23.12,8.18-23.22,8.27l-0.64-0.77c0.11-0.09,10.85-8.98,23.9-8.51c10.92,0.41,29.35,7.92,39.36,12.35 c3.43,1.52,7.08,2.32,10.85,2.39l39.22,0.71L362.96,302.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M297.11,302.75c-17.83-9.71-33.23-5.67-33.38-5.62l-0.26-0.96c0.16-0.04,15.92-4.2,34.12,5.71L297.11,302.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M232.44,297.44l-0.56,0.82c-5.76-3.96-12.96-5.28-19.75-3.62l-1.7,0.42c-0.78,0.28-1.59,0.55-2.41,0.81 c-6.21,1.97-13.57,3.4-21.38,4.42c-14.29,1.87-30.07,2.38-43.07,2.38c-15.51,0-27.04-0.73-27.31-0.75l0.06-1 c0.49,0.04,39.1,2.47,70.35-1.65c7.83-1.03,15.21-2.47,21.4-4.47c0.71-0.22,1.4-0.46,2.07-0.7l1.76-0.43 C218.96,291.94,226.45,293.31,232.44,297.44z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M207.91,315.94l-21.08-0.44c-0.06-1.11-0.11-2.26-0.15-3.45c-0.05-1.35-0.08-2.75-0.09-4.19v-0.01 l21.15-2.91c-0.01,0.95-0.02,1.9-0.02,2.85C207.72,310.51,207.78,313.24,207.91,315.94z"
  }))), /*#__PURE__*/React.createElement("g", null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M255.53,80.72c-4.14,1.11-8.5,2.38-13.02,3.75c0,0.01,0,0.01,0,0.01c-3.73,1.15-7.58,2.38-11.5,3.69 c-3.52,1.17-7.12,2.42-10.77,3.73c-3.48,1.25-6.88,2.5-10.19,3.78c-11.49,4.4-21.95,8.89-30.79,13.12 c-1.96-10.89,0.6-21.87,6.61-30.63c4.73-6.9,11.61-12.43,20.08-15.48c5.95-2.14,12.05-2.82,17.96-2.23 c2.7,0.25,5.34,0.78,7.91,1.56h0.01C241.61,64.99,250.18,71.53,255.53,80.72z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M261.14,100.44c0.48,17.34-10.1,33.76-27.32,39.94c-14.49,5.2-29.95,1.81-40.84-7.54 c-2.18-1.87-4.17-3.97-5.94-6.3c-0.03-0.05-0.08-0.1-0.11-0.15c-1.53-2.01-2.88-4.19-4.03-6.52c-0.7-1.41-1.32-2.88-1.86-4.39 c-0.55-1.52-1-3.04-1.35-4.57c5.52-2.64,12.19-5.54,19.67-8.56c6.47-2.62,13.56-5.32,21-7.99c7.88-2.82,15.44-5.36,22.42-7.54 c4.96-1.54,9.61-2.9,13.87-4.06c0.78,1.55,1.48,3.16,2.09,4.84c0.61,1.69,1.09,3.38,1.47,5.09 C260.78,95.26,261.09,97.87,261.14,100.44z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M256.64,82.75c-4.26,1.16-8.91,2.53-13.87,4.06c-6.98,2.18-14.55,4.72-22.42,7.54 c-16.03,5.75-30.35,11.63-40.66,16.55c-0.16-0.7-0.32-1.41-0.44-2.11c11.39-5.46,25.49-11.34,40.99-16.9 c7.7-2.77,15.19-5.25,22.27-7.42c0,0,0,0,0-0.01c4.52-1.38,8.87-2.64,13.02-3.75C255.92,81.38,256.29,82.06,256.64,82.75z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M242.95,90.66c0,22.39-17.07,40.54-38.13,40.54c-3.25,0-6.41-0.44-9.41-1.25c-2.94-0.79-5.74-1.94-8.36-3.41 c-0.03-0.05-0.08-0.1-0.11-0.15c-1.53-2.01-2.88-4.19-4.03-6.52c-0.7-1.41-1.32-2.88-1.86-4.39c-0.55-1.52-1-3.04-1.35-4.57 c-0.16-0.7-0.32-1.41-0.44-2.11c-0.61-3.35-0.78-6.7-0.55-10.01c0.48-7.43,3-14.56,7.16-20.62c4.73-6.9,11.61-12.43,20.08-15.48 c5.95-2.14,12.05-2.82,17.96-2.23c2.7,0.25,5.34,0.78,7.91,1.56h0.01c5.58,5.95,9.43,13.74,10.69,22.44c0,0.01,0,0.01,0,0.01 c0.1,0.77,0.2,1.55,0.26,2.33C242.89,88.08,242.95,89.36,242.95,90.66z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M255.54,80.72c0.39,0.67,0.75,1.34,1.11,2.03c14.82-4.04,24.78-5.58,25.51-3.55 c0.73,2.03-7.94,7.18-21.95,13.49c-9.69,4.36-21.93,9.27-35.39,14.1c-16.04,5.75-30.83,10.32-41.91,13.09 c-11.68,2.91-19.25,3.83-19.88,2.07c-0.63-1.75,5.8-5.85,16.67-11.03c-0.16-0.7-0.32-1.41-0.44-2.11 c-18.29,8.78-43.82,21.77-42.49,25.48c1.36,3.78,29.79-2.78,50.17-7.89c12-3,26.16-7.32,41.12-12.69 c12.09-4.34,23.33-8.87,33.09-13.25C284,90.2,307.74,76.4,306.23,72.19C304.75,68.05,278.99,74.38,255.54,80.72z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.8678,
    y1: 79.1435,
    x2: 231.3363,
    y2: 79.1435
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8EE5B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C4D8"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M231.01,88.17c-1.02,4.16-4.53,8.02-11.09,9.46c-4.58,1-7.54,0.02-9.87-1.95 c-4.48-3.78-6.67-11.18-13.64-15.23c-3.69-2.14-7.34-2.59-10.54-2.27c4.73-6.9,11.61-12.43,20.08-15.48 c5.95-2.14,12.05-2.82,17.96-2.23c8.38,7.65-9.45,12.19-0.36,14.72C229.45,76.83,232.36,82.75,231.01,88.17z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 178.6064,
    y1: 115.4359,
    x2: 202.1908,
    y2: 115.4359
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8EE5B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C4D8"
    }
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M195.41,129.95c-0.76,1.03-1.56,2-2.42,2.89c-2.18-1.87-4.17-3.97-5.94-6.3c-0.03-0.05-0.08-0.1-0.11-0.15 c-1.53-2.01-2.88-4.19-4.03-6.52c-0.7-1.41-1.32-2.88-1.86-4.39c-0.55-1.52-1-3.04-1.35-4.57c-0.16-0.7-0.32-1.41-0.44-2.11 c-0.61-3.35-0.78-6.7-0.55-10.01c4.59-1.08,10.44-1.25,17.01,1.15c1.49,0.54,2.7,1.37,3.64,2.41 C204.76,108.27,201.87,121.23,195.41,129.95z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.9647,
    y1: 100.249,
    x2: 253.6848,
    y2: 100.249
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8EE5B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C4D8"
    }
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M224.86,74.96c-8.12-0.08-10.16,15.67-28.17,15.24c-11.84-0.28-15.8,25.34-1.86,32.88 c16.94,9.16,17.82-11,46.14-1.75C258.92,127.19,261.43,75.32,224.86,74.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 192.5301,
    y1: 81.0504,
    x2: 202.8132,
    y2: 81.0504
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8EE5B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C4D8"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M197.05,75.99c0,0-8.55,6.95-2.13,10.45C201.34,89.93,207.84,71.28,197.05,75.99z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M232.89,107.45c0,0,61.23-23.08,62.46-32.23"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M149.74,130.43c6.44-0.76,22.46-4.41,22.46-4.41"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0033 -0.2536 0.245 0.9695 359.0912 240.5064)",
    className: "st16 st28 st29"
  }, "A")))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "DESIGNED_BY_FREEPIK",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_21_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_29_",
    className: "st30",
    d: "M51.57,462.68c-0.43,0.44-0.8,0.93-1.11,1.45l-0.47-0.24c-0.07-0.3-0.35-0.5-0.66-0.47 c-0.33,0.04-0.57,0.34-0.53,0.67c0.04,0.33,0.34,0.57,0.67,0.53c0.07-0.01,0.13-0.03,0.18-0.05l0.45,0.23 c-0.25,0.55-0.43,1.14-0.54,1.74l0.75,0.13c0.23-1.31,0.85-2.51,1.79-3.47L51.57,462.68z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    className: "st30",
    d: "M57.05,460.37c-0.17,0-0.34,0.01-0.51,0.02l-0.07-0.63c0.19-0.15,0.3-0.39,0.27-0.64 c-0.05-0.39-0.4-0.67-0.79-0.63c-0.39,0.05-0.67,0.4-0.63,0.8c0.03,0.25,0.19,0.46,0.41,0.56l0.07,0.62 c-0.71,0.12-1.4,0.33-2.06,0.65l0.33,0.68c0.93-0.45,1.94-0.67,3-0.67c0.5,0,0.99,0.05,1.47,0.16l0.16-0.74 C58.16,460.43,57.61,460.37,57.05,460.37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    className: "st30",
    d: "M63.66,462.92c0.33-0.04,0.57-0.34,0.53-0.67c-0.04-0.33-0.34-0.57-0.67-0.53 c-0.31,0.04-0.54,0.3-0.53,0.61l-0.42,0.36c-0.42-0.43-0.89-0.81-1.41-1.14l-0.4,0.64c1.13,0.71,2.02,1.73,2.56,2.93l0.69-0.31 c-0.25-0.55-0.57-1.07-0.94-1.54l0.4-0.35C63.53,462.93,63.59,462.93,63.66,462.92z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    className: "st30",
    d: "M56.51,470.58c-0.39,0.02-0.77,0.03-1.16,0.03c-0.88,0-1.73-0.06-2.48-0.18 c-0.39-0.06-0.85-0.16-1.27-0.29c1.05,1.86,3.07,3.12,5.39,3.12c2.86,0,5.26-1.92,5.95-4.5c-0.68,0.45-1.51,0.83-2.46,1.12 C59.3,470.26,57.93,470.5,56.51,470.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_22_",
    className: "st30",
    d: "M57.05,461.89c-3.35,0-6.08,2.67-6.08,5.94c0,0.43,0.05,0.85,0.14,1.26 c0.67,0.48,2.71,0.89,5.35,0.73c2.88-0.17,5.3-0.96,6.67-2.16c0-0.2-0.02-0.39-0.04-0.58 C62.71,464.12,60.11,461.89,57.05,461.89z M54.9,468.4c-1.02,0-1.85-0.83-1.85-1.85c0-1.02,0.83-1.85,1.85-1.85 c1.02,0,1.85,0.83,1.85,1.85C56.75,467.57,55.92,468.4,54.9,468.4z M59.63,467.5c-0.75,0-1.36-0.61-1.36-1.36 s0.61-1.36,1.36-1.36s1.36,0.61,1.36,1.36S60.38,467.5,59.63,467.5z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st30",
    d: "M73.06,463.76c-0.29-0.12-0.81-0.31-1.38-0.24c-0.55,0.07-0.84,0.34-0.84,1.01v0.87h2.23 v1.72h-2.23v5.45H68.9v-5.45h-1.34v-1.72h1.34v-0.89c0-1.68,0.9-2.78,2.57-2.78c0.64,0,1.16,0.12,1.59,0.31V463.76z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    className: "st30",
    d: "M77.76,467.09c-0.18-0.03-0.36-0.05-0.53-0.05c-0.9,0-1.51,0.55-1.51,1.61v3.91h-1.93v-7.17 h1.87v0.79c0.45-0.67,1.14-0.98,2.02-0.98c0.41,0,0.85,0.13,1.09,0.34L77.76,467.09z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    className: "st30",
    d: "M85.43,468.97c0,0.22-0.01,0.49-0.04,0.65h-5.08c0.21,1.04,0.93,1.49,1.84,1.49 c0.62,0,1.29-0.25,1.81-0.69l1.13,1.24c-0.81,0.75-1.85,1.09-3.06,1.09c-2.2,0-3.72-1.5-3.72-3.75c0-2.26,1.48-3.8,3.63-3.8 C84.01,465.2,85.42,466.73,85.43,468.97z M80.31,468.3h3.17c-0.18-0.92-0.73-1.44-1.56-1.44 C81.02,466.86,80.48,467.41,80.31,468.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st30",
    d: "M93.08,468.97c0,0.22-0.01,0.49-0.04,0.65h-5.08c0.21,1.04,0.93,1.49,1.84,1.49 c0.62,0,1.29-0.25,1.81-0.69l1.13,1.24c-0.81,0.75-1.85,1.09-3.06,1.09c-2.2,0-3.72-1.5-3.72-3.75c0-2.26,1.48-3.8,3.63-3.8 C91.66,465.2,93.07,466.73,93.08,468.97z M87.97,468.3h3.18c-0.18-0.92-0.73-1.44-1.56-1.44 C88.67,466.86,88.14,467.41,87.97,468.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st30",
    d: "M101.43,468.97c0,2.15-1.5,3.77-3.47,3.77c-0.96,0-1.64-0.38-2.11-0.93v3.71h-1.92v-10.13 h1.89v0.79c0.47-0.58,1.15-0.98,2.14-0.98C99.93,465.2,101.43,466.82,101.43,468.97z M95.75,468.97c0,1.13,0.75,1.98,1.84,1.98 c1.14,0,1.85-0.88,1.85-1.98c0-1.1-0.71-1.98-1.85-1.98C96.5,467,95.75,467.84,95.75,468.97z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st30",
    d: "M104.53,463.05c0,0.7-0.54,1.23-1.24,1.23c-0.7,0-1.23-0.53-1.23-1.23 c0-0.7,0.53-1.24,1.23-1.24C103.99,461.8,104.53,462.35,104.53,463.05z M104.27,472.56h-1.93v-7.17h1.93V472.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st30",
    d: "M107.5,467.95l2.7-2.55h2.37l-3.48,3.38l3.5,3.8h-2.38l-2.72-2.9v2.9h-1.93v-10.66h1.93 V467.95z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M-24.12,472.5v-1.05c-0.53,0.72-1.39,1.23-2.39,1.23c-1.85,0-3.15-1.41-3.15-3.71 c0-2.26,1.29-3.72,3.15-3.72c0.95,0,1.82,0.47,2.39,1.25v-3.76h1.1v9.77H-24.12z M-24.12,470.58v-3.21 c-0.4-0.62-1.25-1.14-2.12-1.14c-1.42,0-2.27,1.17-2.27,2.74c0,1.57,0.85,2.72,2.27,2.72C-25.37,471.69-24.52,471.2-24.12,470.58 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M-21.61,468.95c0-2.05,1.46-3.71,3.49-3.71c2.14,0,3.4,1.67,3.4,3.79v0.28h-5.73 c0.09,1.33,1.03,2.45,2.55,2.45c0.81,0,1.63-0.32,2.18-0.89l0.53,0.72c-0.7,0.7-1.66,1.08-2.81,1.08 C-20.1,472.67-21.61,471.17-21.61,468.95z M-18.13,466.16c-1.51,0-2.26,1.27-2.31,2.36h4.64 C-15.82,467.46-16.52,466.16-18.13,466.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M-13.93,471.56l0.57-0.79c0.47,0.54,1.36,1.01,2.33,1.01c1.08,0,1.67-0.51,1.67-1.22 c0-1.71-4.38-0.66-4.38-3.28c0-1.1,0.95-2.04,2.64-2.04c1.2,0,2.05,0.45,2.62,1.03l-0.51,0.76c-0.42-0.51-1.2-0.89-2.11-0.89 c-0.97,0-1.57,0.48-1.57,1.11c0,1.55,4.38,0.53,4.38,3.28c0,1.19-0.95,2.14-2.78,2.14C-12.23,472.67-13.21,472.32-13.93,471.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M-7.06,463.68c0-0.41,0.34-0.75,0.73-0.75c0.41,0,0.75,0.34,0.75,0.75c0,0.41-0.34,0.73-0.75,0.73 C-6.72,464.41-7.06,464.09-7.06,463.68z M-6.87,472.5v-7.08h1.1v7.08H-6.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M-3.95,474.32l0.56-0.82c0.59,0.7,1.29,0.97,2.3,0.97c1.17,0,2.27-0.57,2.27-2.12v-1.01 c-0.51,0.72-1.38,1.26-2.37,1.26c-1.85,0-3.15-1.38-3.15-3.66c0-2.27,1.29-3.68,3.15-3.68c0.95,0,1.8,0.47,2.37,1.25v-1.07h1.1 v6.87c0,2.34-1.64,3.08-3.37,3.08C-2.3,475.37-3.12,475.14-3.95,474.32z M1.17,470.46v-3.09c-0.38-0.62-1.23-1.14-2.11-1.14 c-1.42,0-2.27,1.13-2.27,2.7c0,1.55,0.85,2.7,2.27,2.7C-0.06,471.62,0.79,471.08,1.17,470.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M8.88,472.5v-4.63c0-1.25-0.63-1.64-1.58-1.64c-0.86,0-1.68,0.53-2.09,1.1v5.17H4.1v-7.08h1.1v1.03 c0.5-0.59,1.46-1.2,2.52-1.2c1.48,0,2.26,0.75,2.26,2.29v4.97H8.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M11.4,468.95c0-2.05,1.46-3.71,3.49-3.71c2.14,0,3.4,1.67,3.4,3.79v0.28h-5.73 c0.09,1.33,1.03,2.45,2.55,2.45c0.81,0,1.63-0.32,2.18-0.89l0.53,0.72c-0.7,0.7-1.66,1.08-2.81,1.08 C12.9,472.67,11.4,471.17,11.4,468.95z M14.87,466.16c-1.51,0-2.26,1.27-2.31,2.36h4.64C17.18,467.46,16.48,466.16,14.87,466.16z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M24.81,472.5v-1.05c-0.53,0.72-1.39,1.23-2.39,1.23c-1.85,0-3.15-1.41-3.15-3.71 c0-2.26,1.29-3.72,3.15-3.72c0.95,0,1.82,0.47,2.39,1.25v-3.76h1.1v9.77H24.81z M24.81,470.58v-3.21 c-0.4-0.62-1.25-1.14-2.12-1.14c-1.42,0-2.27,1.17-2.27,2.74c0,1.57,0.85,2.72,2.27,2.72C23.57,471.69,24.42,471.2,24.81,470.58z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M31.15,472.5v-9.77h1.1v3.76c0.57-0.78,1.42-1.25,2.39-1.25c1.85,0,3.15,1.46,3.15,3.72 c0,2.3-1.3,3.71-3.15,3.71c-1,0-1.86-0.51-2.39-1.23v1.05H31.15z M34.36,471.69c1.44,0,2.29-1.16,2.29-2.72 c0-1.57-0.85-2.74-2.29-2.74c-0.86,0-1.73,0.53-2.11,1.14v3.21C32.63,471.2,33.5,471.69,34.36,471.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M38.99,474.27c0.16,0.07,0.43,0.12,0.6,0.12c0.48,0,0.81-0.16,1.05-0.75l0.47-1.07l-2.96-7.15h1.19 l2.36,5.8l2.34-5.8h1.2l-3.54,8.51c-0.42,1.03-1.14,1.42-2.08,1.44c-0.23,0-0.6-0.04-0.81-0.1L38.99,474.27z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainbg);
export default __webpack_public_path__ + "static/media/mainbg.a03abb1e274696c90a3ed00435a081ef.svg";
export { ForwardRef as ReactComponent };